export default __webpack_public_path__ + "static/media/purple-ball.c6466acb.svg";